import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { AUTHENTICATION_TYPE } from '../constants/types'
import { BASE_URL } from '../constants/urls'

export const apiKeyService = createApi({
  reducerPath: AUTHENTICATION_TYPE,
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL
  }),
  endpoints: (builder) => ({
    apiKey: builder.query<any, string>({
      query: (email) => ({
        url: `/apikey/${encodeURIComponent(email)}`
      })
    })
  })
})

export const { useLazyApiKeyQuery } = apiKeyService
